/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { sendRequestAndReceiveResponse, toFileNameLookupBody } from '../common/common';
import { GetGeneralServiceInformatioonNamenURLEndpoint } from '../common/constants';
const HANDLE_GS_UPLOAD_DIALOG_CLICK = 'HANDLE_GS_UPLOAD_DIALOG_CLICK';
const CLEAR_UPLOAD_GSINFO_STORE = 'CLEAR_UPLOAD_GSINFO_STORE';
const SERVICE_GSINFO = 'SERVICE_GSINFO';
const GSINFO_INFORMATION_CHANGE = 'GS_INFORMATION_CHANGE';
const UPDATE_FILE_NAME = 'UPDATE_FILE_NAME';
const RELEASE_DATE_CHANGE = 'RELEASE_DATE_CHANGE';
const UPDATE_GS_INFO_DATA = 'UPDATE_GS_INFO_DATA';
const LOADING_GSINFO_DETAIL_ON_NAME = 'LOADING_GSINFO_DETAIL_ON_NAME';
const UPDATE_GSINFO_DATA_USING_UPLOAD = 'UPDATE_GSINFO_DATA_USING_UPLOAD';
const GSINFO_ACTIVATE_CHANGE = 'GSINFO_ACTIVATE_CHANGE';
const initialState = {
    data: {},
    uploadDialogOpen: false,
    isEdit: false,
    selectedPdf: undefined,
    fileName: '',
    releaseDate: new Date(new Date().setDate(15)),
    displayName: '',
    checked: true

}

export const actionCreators = {
    handleUploadGsInfoDialogClick: (isOpen: boolean) => async (dispatch: any, getState: any) => {
        dispatch({ type: HANDLE_GS_UPLOAD_DIALOG_CLICK, isOpen });
    },
    clearAll: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_UPLOAD_GSINFO_STORE });
    },
    UpdateGsSelectedPdf: (selectedPdf: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: SERVICE_GSINFO, selectedPdf });
    },
    handleGsInformationChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: GSINFO_INFORMATION_CHANGE, event });
    },
    UpdateGsFileName: (fileName: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_FILE_NAME, fileName });
        let a = { value: true };
        dispatch({ type: LOADING_GSINFO_DETAIL_ON_NAME, a });
        let gsData = await sendRequestAndReceiveResponse(toFileNameLookupBody(fileName), GetGeneralServiceInformatioonNamenURLEndpoint);
        if (gsData.displayName != undefined) {
            await dispatch({ type: UPDATE_GSINFO_DATA_USING_UPLOAD, gsData });
        }
        a = { value: false };
        dispatch({ type: LOADING_GSINFO_DETAIL_ON_NAME, a });
    },
    handleGsreleaseDateChange: (date: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: RELEASE_DATE_CHANGE, date });
    },
    UpdateGSInfoData: (gsinfoData: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_GS_INFO_DATA, gsinfoData });
    },
    handleGsActivateChange: (event: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: GSINFO_ACTIVATE_CHANGE, event });
    },
}

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case HANDLE_GS_UPLOAD_DIALOG_CLICK:
            return {
                ...state,
                uploadDialogOpen: action.isOpen
            };
        case SERVICE_GSINFO:
            return {
                ...state,
                selectedPdf: action.selectedPdf
            };
        case CLEAR_UPLOAD_GSINFO_STORE:
            return initialState;
        case GSINFO_INFORMATION_CHANGE:
            return {
                ...state,
                [action.event.target.name]: action.event.target.value
            };
        case UPDATE_FILE_NAME:
            return {
                ...state,
                fileName: action.fileName
            };
        case UPDATE_GS_INFO_DATA: {
            const smd = action.gsinfoData;
            console.log(action);
            return {
                ...state,
                selectedPdf: smd.url,
                gsPartNo: smd.gsPartNumber,
                displayName: smd.displayName,
                fileName: smd.fileName,
                description: smd.description,
                documentType: smd.documentType,
                revision: smd.revision,
                checked: smd.active,
                releaseDate: new Date(smd.startDate),
                isEdit: true
            };
        }
        case UPDATE_GSINFO_DATA_USING_UPLOAD: {
            const smd = action.gsData;
            console.log(action.gsData);
            return {
                ...state,
                gsPartNo: smd.gsPartNumber,
                displayName: smd.displayName,
                fileName: smd.fileName,
                documentType: smd.documentType,
                revision: smd.revision,
                description: smd.description,
                releaseDate: new Date(smd.startDate),
                checked: smd.active,
                isDetailLoadingOnManualName: false,
                isFileChanged: true
            };
            }
        case RELEASE_DATE_CHANGE:
            return {
                ...state,
                releaseDate: new Date(new Date(action.date).setDate(15))
            };
        case GSINFO_ACTIVATE_CHANGE:
            console.log(action.event.target.checked);
            return {
                ...state,
                [action.event.target.name]: action.event.target.checked
            };
    }

    return state;
};
